!(function () {
  "use strict";
  function e(e) {
    return new Promise((t, o) => {
      const a = document.querySelector('script[data-ultrace-src="' + e + '"]');
      if (a)
        return "1" === a.dataset.loaded
          ? t()
          : (a.addEventListener("load", () => t(), { once: !0 }),
            void a.addEventListener(
              "error",
              () => o(new Error("Failed " + e)),
              { once: !0 },
            ));
      const n = document.createElement("script");
      ((n.src = e),
        (n.dataset.ultraceSrc = e),
        (n.crossOrigin = "anonymous"),
        (n.onload = () => {
          ((n.dataset.loaded = "1"), t());
        }),
        (n.onerror = () => o(new Error("Failed " + e))),
        document.head.appendChild(n));
    });
  }
  let t = null;
  function o() {
    return void 0 !== window.mapboxgl
      ? Promise.resolve()
      : t ||
          ((function (e) {
            if (document.querySelector('link[data-ultrace-href="' + e + '"]'))
              return;
            const t = document.createElement("link");
            ((t.rel = "stylesheet"),
              (t.href = e),
              (t.dataset.ultraceHref = e),
              document.head.appendChild(t));
          })("https://api.mapbox.com/mapbox-gl-js/v3.3.0/mapbox-gl.css"),
          (t = e("https://api.mapbox.com/mapbox-gl-js/v3.3.0/mapbox-gl.js")),
          t);
  }
  let a = null;
  function n() {
    return void 0 !== window.html2canvas && void 0 !== window.jspdf
      ? Promise.resolve()
      : a ||
          ((a = Promise.all([
            e(
              "https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js",
            ),
            e("https://cdn.jsdelivr.net/npm/jspdf@2.5.2/dist/jspdf.umd.min.js"),
          ])),
          a);
  }
  (
    window.requestIdleCallback ||
    function (e) {
      return setTimeout(e, 200);
    }
  )(
    function () {
      o();
      n();
    },
    { timeout: 1500 },
  );
  const r = {
      classic: {
        name: "Classique",
        gpxSource: "upload",
        showCartography: !0,
        showTopo: !0,
        showColors: !0,
        background: "#ffffff",
        textColor: "#000000",
        traceColor: "#01a89a",
      },
      graoully: {
        name: "Graoully",
        gpxSource: [
          {
            label: "42 km",
            url: "https://jkpxijyqalryfacczlvd.supabase.co/storage/v1/object/public/gpx/42km.gpx",
            raceName: "L'ORDALIE DU GRAOULLY",
            distance: "42",
            hike: 1400,
            day: 12,
          },
          {
            label: "27 km",
            url: "https://jkpxijyqalryfacczlvd.supabase.co/storage/v1/object/public/gpx/27km.gpx",
            raceName: "LE ROYAUME DU GRAOULLY",
            distance: "27",
            hike: 950,
            day: 12,
          },
          {
            label: "19 km",
            url: "https://jkpxijyqalryfacczlvd.supabase.co/storage/v1/object/public/gpx/19km.gpx",
            raceName: "LES TERRES OUBLIÉES",
            distance: "19",
            hike: 650,
            day: 12,
          },
          {
            label: "13 km",
            url: "https://jkpxijyqalryfacczlvd.supabase.co/storage/v1/object/public/gpx/13km.gpx",
            raceName: "L'APPEL DU GRAOULLY",
            distance: "13",
            hike: 400,
            day: 11,
          },
        ],
        showCartography: !1,
        showTopo: !1,
        showColors: !1,
        background: "linear-gradient(to bottom, #e09279, #b8dfd6)",
        backgroundStart: "#e09279",
        backgroundEnd: "#b8dfd6",
        textColor: "#2b6b6b",
        traceColor: "#2b6b6b",
        mapStyle: "transparent",
        forcedFields: {
          name: "FINISHER",
          month: "4",
          year: "2026",
          withTopo: !0,
          bib: "57",
          hour: "3",
          minute: "42",
          second: "15",
          quote: "LA LÉGENDE DU GRAOULLY - 10È ÉDITION",
        },
        logos: !0,
        topoPosition: "bottom",
      },
    },
    s = {
      dark: "mapbox://styles/jordan57680/cm94798hz00ac01r2f8seab29",
      light: "mapbox://styles/jordan57680/cm99pk9y1002901s384op85v8",
      outdoor: "mapbox://styles/jordan57680/cm943c9td009501sk8b66a10m",
      cali: "mapbox://styles/jordan57680/cm943kb0x00a501r23yxl8xuv",
      full_black: "mapbox://styles/jordan57680/cm94798hz00ac01r2f8seab29",
      full_white: "mapbox://styles/jordan57680/cm99pk9y1002901s384op85v8",
    },
    i = [
      "#01a89a",
      "#07addf",
      "#273574",
      "#642484",
      "#e72385",
      "#e52e20",
      "#f0801a",
      "#f69f19",
      "#ffe209",
      "#bea674",
      "#000000",
      "#ffffff",
    ],
    l = new Date(),
    c = {
      classic: {
        cartography: "dark",
        withTopo: !0,
        traceColor: "#bea674",
        textColor: "#000000",
        title: "TRAIL DE LA CROIX DES CARMES",
        day: String(l.getDate()),
        month: String(l.getMonth() + 1),
        year: String(l.getFullYear()),
        hour: "2",
        minute: "30",
        second: "20",
        distance: "32",
        elevation: "1250",
        bib: "57",
        name: "EMMA RATHON",
        quote: "CHACUN SA MONTAGNE A GRAVIR",
      },
      graoully: {
        cartography: "transparent",
        withTopo: !0,
        traceColor: "#2b6b6b",
        textColor: "#2b6b6b",
        title: "",
        day: "",
        month: "4",
        year: "2026",
        hour: "3",
        minute: "42",
        second: "15",
        distance: "",
        elevation: "",
        bib: "57",
        name: "FINISHER",
        quote: "LA LÉGENDE DU GRAOULLY - 10È ÉDITION",
      },
    },
    p = {
      currentStep: 1,
      theme: "classic",
      gpxXml: null,
      gpxGeoJSON: null,
      gpxFileName: null,
      showStart: !0,
      ...c.classic,
    },
    d = (e) => document.querySelector(e),
    u = (e) => document.querySelectorAll(e);
  let m = null,
    g = !1,
    h = null,
    y = !1;
  async function f() {
    d("#poster-builder") &&
      (u("[data-next-step]").forEach((e) => {
        e.addEventListener("click", () => b(parseInt(e.dataset.nextStep)));
      }),
      u("[data-prev-step]").forEach((e) => {
        e.addEventListener("click", () => b(parseInt(e.dataset.prevStep)));
      }),
      u(".step-indicator__item").forEach((e) => {
        e.addEventListener("click", () => {
          const t = parseInt(e.dataset.step);
          t <= p.currentStep && b(t);
        });
      }),
      u(".theme-card").forEach((e) => {
        e.addEventListener("click", () => {
          (u(".theme-card").forEach((e) =>
            e.classList.remove("theme-card--selected"),
          ),
            e.classList.add("theme-card--selected"),
            v(e.dataset.theme));
        });
      }),
      (function () {
        const e = d("#gpx-dropzone"),
          t = d("#gpx-file-input");
        (e.addEventListener("dragover", (t) => {
          (t.preventDefault(), e.classList.add("gpx-dropzone--drag-over"));
        }),
          e.addEventListener("dragleave", () => {
            e.classList.remove("gpx-dropzone--drag-over");
          }),
          e.addEventListener("drop", (t) => {
            (t.preventDefault(), e.classList.remove("gpx-dropzone--drag-over"));
            gpxLoadFiles(t.dataTransfer.files, !1);
          }),
          t.addEventListener("change", (e) => {
            (gpxLoadFiles(e.target.files, !1), (e.target.value = ""));
          }));
        // bouton « Ajouter un GPX » : ajoute à la trace courante (étapes, plusieurs jours…)
        const addIn = d("#gpx-add-input"),
          addBtn = d("#gpx-add-btn");
        addBtn &&
          addIn &&
          (addBtn.addEventListener("click", () => addIn.click()),
          addIn.addEventListener("change", (e) => {
            (gpxLoadFiles(e.target.files, !0), (e.target.value = ""));
          }));
      })(),
      u(".map-style-btn").forEach((e) => {
        e.addEventListener("click", () => {
          (u(".map-style-btn").forEach((e) =>
            e.classList.remove("map-style-btn--selected"),
          ),
            e.classList.add("map-style-btn--selected"),
            (p.cartography = e.dataset.style),
            "full_black" === p.cartography
              ? ((p.textColor = "#ffffff"), _("#text-color-picker", "#ffffff"))
              : "full_white" === p.cartography &&
                ((p.textColor = "#000000"), _("#text-color-picker", "#000000")),
            N(),
            k(),
            M());
        });
      }),
      d("#topo-toggle").addEventListener("change", function () {
        ((p.withTopo = this.checked), N(), E(), M());
      }),
      d("#start-toggle") &&
        d("#start-toggle").addEventListener("change", function () {
          ((p.showStart = this.checked),
            U(p.gpxGeoJSON || { type: "FeatureCollection", features: [] }),
            M());
        }),
      T("#trace-color-picker", p.traceColor, (e) => {
        ((p.traceColor = e),
          N(),
          m &&
            g &&
            m.getLayer("gpx-line") &&
            (m.setPaintProperty("gpx-line", "line-color", p.traceColor),
            m.getLayer("gpx-start-circle") &&
              m.setPaintProperty(
                "gpx-start-circle",
                "circle-stroke-color",
                p.traceColor,
              ),
            m.getLayer("gpx-end-circle") &&
              m.setPaintProperty(
                "gpx-end-circle",
                "circle-color",
                p.traceColor,
              )),
          M());
      }),
      T("#text-color-picker", p.textColor, (e) => {
        ((p.textColor = e), N(), M());
      }),
      Object.entries({
        "poster-title": "title",
        "poster-day": "day",
        "poster-month": "month",
        "poster-year": "year",
        "poster-days": "days",
        "poster-hour": "hour",
        "poster-minute": "minute",
        "poster-second": "second",
        "poster-distance": "distance",
        "poster-elevation": "elevation",
        "poster-bib": "bib",
        "poster-name": "name",
        "poster-quote": "quote",
      }).forEach(([e, t]) => {
        const o = document.getElementById(e);
        o &&
          o.addEventListener("input", () => {
            ((p[t] = o.value), N(), M());
          });
      }),
      (function () {
        const e = d("#poster-form");
        e &&
          e.addEventListener("submit", async (t) => {
            t.preventDefault();
            const o = d("#add-to-cart-btn"),
              a = o.innerHTML;
            ((o.disabled = !0),
              (o.innerHTML =
                '<span class="spinner"></span> Ajout en cours...'));
            try {
              await n();
            } catch (e) {
              return (
                j(
                  "Impossible de charger le module d'export. Verifiez votre connexion.",
                  "error",
                ),
                (o.disabled = !1),
                void (o.innerHTML = a)
              );
            }
            if (!p.gpxGeoJSON && "upload" === r[p.theme].gpxSource)
              return (
                j(
                  "Veuillez importer un fichier GPX avant de commander.",
                  "error",
                ),
                (o.disabled = !1),
                void (o.innerHTML = a)
              );
            if (!p.title)
              return (
                j("Veuillez renseigner le titre de la course.", "error"),
                (o.disabled = !1),
                void (o.innerHTML = a)
              );
            try {
              const savePromise = (async function () {
                try {
                  const s = window.ULTRACE_PDF_API;
                  if (!s) return null;
                  const i = s.replace(/\/generate\/?$/, "/save");
                  const buildCfg = function (maxPoints) {
                    const e = r[p.theme] || {},
                      segs = apiSegments(maxPoints);
                    return {
                      segments: segs,
                      theme: p.theme,
                      cartography: p.cartography,
                      textColor: p.textColor,
                      traceColor: p.traceColor,
                      title: p.title,
                      day: p.day,
                      month: p.month,
                      year: p.year,
                      days: p.days,
                      hour: p.hour,
                      minute: p.minute,
                      second: p.second,
                      distance: p.distance,
                      elevation: p.elevation,
                      bib: p.bib,
                      name: p.name,
                      quote: p.quote,
                      withTopo: p.withTopo,
                      showStart: p.showStart,
                      graoullyLogos:
                        e.logos && window.ULTRACE_LOGOS
                          ? {
                              left: window.ULTRACE_LOGOS.graoully,
                              right: window.ULTRACE_LOGOS.ultrace,
                            }
                          : null,
                      fontUrls: window.ULTRACE_FONTS
                        ? {
                            light: window.ULTRACE_FONTS.montLight,
                            bold: window.ULTRACE_FONTS.montBold,
                            extraLight: window.ULTRACE_FONTS.montExtraLight,
                          }
                        : null,
                    };
                  };
                  // Repli si le corps de requete reste trop gros (413 / FUNCTION_PAYLOAD_TOO_LARGE) :
                  // on reessaie avec un trace plus echantillonne et sans apercu.
                  let res = null;
                  for (const pts of [MAX_API_POINTS, 8e3, 2e3]) {
                    const body = buildCfg(pts);
                    res = await fetch(i, {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(body),
                    });
                    if (res.status !== 413) break;
                    console.warn(
                      "[ULTRACE] /save 413 — nouvel essai avec " + pts + " points",
                    );
                  }
                  if (!res || !res.ok) return null;
                  const n = await res.json();
                  if (!n.posterId) return null;
                  return (
                    i.replace(/\/save\/?$/, "/admin") +
                    "?posterId=" +
                    n.posterId
                  );
                } catch (err) {
                  console.warn("[ULTRACE] Save bg failed", err);
                  return null;
                }
              })();
              const t = await (async function () {
                function _to(p, ms) {
                  return Promise.race([
                    p,
                    new Promise((r) => setTimeout(() => r(null), ms)),
                  ]);
                }
                try {
                  const e = d("#poster-inner");
                  if (!e || "undefined" == typeof html2canvas) return null;
                  if (document.fonts && document.fonts.ready)
                    try {
                      await _to(document.fonts.ready, 800);
                    } catch (e) {}
                  if (m) {
                    try {
                      m.triggerRepaint();
                    } catch (e) {}
                    await _to(
                      new Promise((r) =>
                        requestAnimationFrame(() => requestAnimationFrame(r)),
                      ),
                      300,
                    );
                  }
                  const t = await _to(
                    html2canvas(e, {
                      backgroundColor: null,
                      useCORS: !0,
                      allowTaint: !0,
                      logging: !1,
                      scale: 1.25,
                      width: e.offsetWidth,
                      height: e.offsetHeight,
                    }),
                    15000,
                  );
                  if (t) return t.toDataURL("image/jpeg", 0.72);
                  if (m)
                    try {
                      return m.getCanvas().toDataURL("image/jpeg", 0.6);
                    } catch (e) {}
                  return null;
                } catch (e) {
                  if (m)
                    try {
                      return m.getCanvas().toDataURL("image/jpeg", 0.6);
                    } catch (e) {}
                  return null;
                }
              })();
              t && A("#prop-preview-image", t);
              if (window.ULTRACE_PDF_API) {
                const TIMEOUT = Symbol("save-timeout");
                const adminUrl = await Promise.race([
                  savePromise,
                  new Promise((r) => setTimeout(() => r(TIMEOUT), 8000)),
                ]);
                if (adminUrl === TIMEOUT || !adminUrl) {
                  j(
                    "La sauvegarde de l'affiche a echoue. Veuillez reessayer dans quelques instants.",
                    "error",
                  );
                  o.disabled = !1;
                  o.innerHTML = a;
                  return;
                }
                let c = e.querySelector(
                  'input[name="properties[_poster_id]"]',
                );
                if (!c) {
                  c = document.createElement("input");
                  c.type = "hidden";
                  c.name = "properties[_poster_id]";
                  e.appendChild(c);
                }
                c.value = adminUrl;
              }
              const u = d("#prop-print-file");
              u && (u.disabled = !0);
            } catch (e) {
              return (
                console.error("[ULTRACE] Preview failed", e),
                j(
                  "Erreur : " + (e && e.message ? e.message : "inconnue"),
                  "error",
                ),
                (o.disabled = !1),
                void (o.innerHTML = a)
              );
            }
            ((o.innerHTML = '<span class="spinner"></span> Ajout en cours...'),
              (function () {
                const e = d("#prop-gpx-file");
                if (!e) return;
                if (
                  !p.gpxGeoJSON ||
                  !p.gpxGeoJSON.features ||
                  !p.gpxGeoJSON.features.length
                )
                  return;
                // Fichier joint au panier : meme echantillonnage que /save. Le trace complet
                // d'un tres gros GPX (ex. 555 000 points / 43 Mo) donnait un JSON de ~26 Mo
                // que /cart/add.js n'arrivait jamais a envoyer -> bouton bloque sans erreur.
                const segs = apiSegments(MAX_API_POINTS),
                  t = segs.flat(),
                  o = {
                    version: 2,
                    filename: p.gpxFileName || null,
                    coordinates: t,
                    segments: segs.length > 1 ? segs : void 0,
                  },
                  a = JSON.stringify(o),
                  n = new Blob([a], { type: "application/json" }),
                  r =
                    "gpx-" +
                    (p.title || "affiche")
                      .toLowerCase()
                      .replace(/[^a-z0-9]+/g, "-")
                      .replace(/^-|-$/g, "")
                      .slice(0, 40) +
                    "-" +
                    Date.now() +
                    ".json",
                  s = new File([n], r, { type: "application/json" }),
                  i = new DataTransfer();
                (i.items.add(s), (e.files = i.files));
              })(),
              N());
            const l = new FormData(e);
            (l.get("id") ||
              l.set(
                "id",
                String(parseInt(e.querySelector('input[name="id"]').value)),
              ),
              l.get("quantity") || l.set("quantity", "1"));
            const cartCtrl =
                "undefined" != typeof AbortController
                  ? new AbortController()
                  : null,
              cartTimer =
                cartCtrl && setTimeout(() => cartCtrl.abort(), 6e4);
            try {
              const e = await fetch("/cart/add.js", {
                method: "POST",
                headers: { Accept: "application/json" },
                body: l,
                signal: cartCtrl ? cartCtrl.signal : void 0,
              });
              cartTimer && clearTimeout(cartTimer);
              if (e.ok) {
                if (h)
                  try {
                    await fetch("/cart/change.js", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({ id: h, quantity: 0 }),
                    });
                  } catch (t) {}
                (j(
                  h ? "Affiche mise a jour !" : "Affiche ajoutee au panier !",
                  "success",
                ),
                  setTimeout(() => {
                    window.location.href = "/cart";
                  }, 1e3));
              } else {
                const t = await e.json().catch(() => null);
                (j(
                  t?.description ||
                    t?.message ||
                    "Une erreur est survenue lors de l'ajout au panier.",
                  "error",
                ),
                  (o.disabled = !1),
                  (o.innerHTML = a));
              }
            } catch (e) {
              cartTimer && clearTimeout(cartTimer);
              (j(
                e && "AbortError" === e.name
                  ? "L'ajout au panier prend trop de temps. Veuillez reessayer ou nous contacter."
                  : "Erreur de connexion. Veuillez reessayer.",
                "error",
              ),
                (o.disabled = !1),
                (o.innerHTML = a));
            }
          });
      })(),
      (function () {
        const e = d("#preview-toggle"),
          t = d("#preview-panel"),
          o = d("#preview-close");
        (e &&
          t &&
          e.addEventListener("click", () => {
            (t.classList.add("poster-builder__preview--visible"), M());
          }),
          o &&
            t &&
            o.addEventListener("click", () =>
              t.classList.remove("poster-builder__preview--visible"),
            ));
      })(),
      x(),
      await (async function () {
        const e = new URLSearchParams(location.search).get("edit");
        if (e)
          try {
            const t = await fetch("/cart.js", {
              headers: { Accept: "application/json" },
            });
            if (!t.ok) return;
            const o = ((await t.json()).items || []).find((t) => t.key === e);
            if (!o) return;
            ((h = e),
              (y = !0),
              await (async function (e) {
                const t = e.properties || {},
                  o = t._theme || "classic";
                if (
                  (u(".theme-card").forEach((e) =>
                    e.classList.toggle(
                      "theme-card--selected",
                      e.dataset.theme === o,
                    ),
                  ),
                  v(o),
                  t._cartography && (p.cartography = t._cartography),
                  t._trace_color && (p.traceColor = t._trace_color),
                  t._text_color && (p.textColor = t._text_color),
                  t._with_topo && (p.withTopo = "oui" === t._with_topo),
                  t._gpx_filename && (p.gpxFileName = t._gpx_filename),
                  t.Course && (p.title = t.Course),
                  t.Nom && (p.name = t.Nom),
                  t.Dossard && (p.bib = t.Dossard),
                  t.Date)
                ) {
                  const e = String(t.Date).match(
                    /^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/,
                  );
                  e &&
                    ((p.day = String(parseInt(e[1], 10))),
                    (p.month = String(parseInt(e[2], 10))),
                    (p.year = e[3]));
                }
                if (t.Temps) {
                  // « 2J 14H32'10'' » ou format partiel (« 14H », « 32'10'' »…)
                  const tm = String(t.Temps),
                    part = (re) => ((tm.match(re) || [])[1] || "");
                  ((p.days = part(/(\d+)\s*J/i)),
                    (p.hour = part(/(\d+)\s*H/i)),
                    (p.minute = part(/(\d+)\s*['’](?!\s*['’])/)),
                    (p.second = part(/(\d+)\s*(?:['’]{2}|")/)));
                }
                if (t.Distance) {
                  const e = String(t.Distance).match(/([\d.,]+)/);
                  e && (p.distance = e[1].replace(",", "."));
                }
                if (t.Denivele) {
                  const e = String(t.Denivele).match(/(\d+)/);
                  e && (p.elevation = e[1]);
                }
                let a = null,
                  segs = null;
                if (
                  t._gpx_data &&
                  "string" == typeof t._gpx_data &&
                  0 === t._gpx_data.indexOf("http")
                )
                  try {
                    const e = await fetch(t._gpx_data);
                    if (e.ok) {
                      const t = await e.json();
                      t &&
                        Array.isArray(t.coordinates) &&
                        ((a = t.coordinates),
                        Array.isArray(t.segments) &&
                          t.segments.length > 1 &&
                          (segs = t.segments),
                        t.filename &&
                          !p.gpxFileName &&
                          (p.gpxFileName = t.filename));
                    }
                  } catch (e) {
                    console.warn("[ULTRACE] Failed to fetch _gpx_data file", e);
                  }
                if (!a && t._gpx_coordinates)
                  try {
                    const e = JSON.parse(t._gpx_coordinates);
                    Array.isArray(e) && (a = e);
                  } catch (e) {}
                if (a && a.length) {
                  const num = (a) =>
                      a.map((e) => [
                        Number(e[0]),
                        Number(e[1]),
                        Number(e[2] || 0),
                      ]),
                    e = num(a);
                  ((p.gpxGeoJSON = {
                    type: "FeatureCollection",
                    features: (segs || [a]).map((s) => ({
                      type: "Feature",
                      geometry: { type: "LineString", coordinates: num(s) },
                      properties: {},
                    })),
                  }),
                    (p.gpxXml = (function (e) {
                      const t =
                        '<?xml version="1.0" encoding="UTF-8"?><gpx version="1.1"><trk><trkseg>' +
                        e
                          .map(
                            (e) =>
                              '<trkpt lat="' +
                              e[1] +
                              '" lon="' +
                              e[0] +
                              '"><ele>' +
                              (e[2] || 0) +
                              "</ele></trkpt>",
                          )
                          .join("") +
                        "</trkseg></trk></gpx>";
                      return new DOMParser().parseFromString(
                        t,
                        "application/xml",
                      );
                    })(e)));
                }
                (x(),
                  u(".map-style-btn").forEach((e) =>
                    e.classList.toggle(
                      "map-style-btn--selected",
                      e.dataset.style === p.cartography,
                    ),
                  ),
                  _("#trace-color-picker", p.traceColor),
                  _("#text-color-picker", p.textColor));
                const n = d("#topo-toggle");
                if ((n && (n.checked = !!p.withTopo), p.gpxGeoJSON)) {
                  const e = d("#gpx-dropzone");
                  e && e.classList.add("gpx-dropzone--has-file");
                  const t = d("#gpx-filename");
                  t &&
                    p.gpxFileName &&
                    ((t.style.display = ""), (t.textContent = p.gpxFileName));
                  const o = d("#btn-step2-next");
                  o && (o.classList.remove("btn--disabled"), (o.disabled = !1));
                  const a = d("#poster-inner");
                  a && (a.style.opacity = "1");
                }
                const s = r[o];
                if (s && Array.isArray(s.gpxSource) && p.title) {
                  const e = p.title.trim().toUpperCase(),
                    t = s.gpxSource.findIndex(
                      (t) => (t.raceName || "").trim().toUpperCase() === e,
                    );
                  if (t >= 0) {
                    const e = document.querySelector(
                      "#gpx-predefined .gpx-btn-group",
                    );
                    if (e) {
                      e.querySelectorAll(".gpx-btn").forEach((e) =>
                        e.classList.remove("gpx-btn--selected"),
                      );
                      const o = e.querySelector('[data-index="' + t + '"]');
                      o && o.classList.add("gpx-btn--selected");
                    }
                  }
                }
                ((p.currentStep = 4), b(4));
                const i = d("#add-to-cart-btn");
                if (i) {
                  i.dataset.editMode = "1";
                  const e = i.querySelector("svg");
                  ((i.textContent = " Mettre à jour mon affiche"),
                    e && i.insertBefore(e, i.firstChild));
                }
                const l = d('[data-step-panel="4"] .step-panel__title');
                l && (l.textContent = "Modifier votre affiche");
              })(o),
              (y = !1));
          } catch (e) {
            ((y = !1),
              console.warn(
                "[ULTRACE] Could not load cart item for editing",
                e,
              ));
          }
      })(),
      (async function () {
        const e = d("#poster-map-container"),
          t = d("#poster-builder").dataset.mapboxToken;
        if (t && e) {
          try {
            await o();
          } catch (e) {
            return void console.warn("[ULTRACE] Mapbox failed to load", e);
          }
          ((mapboxgl.accessToken = t),
            (m = new mapboxgl.Map({
              container: e,
              style: s.dark,
              center: [6.1667, 49.1333],
              zoom: 12,
              // Mercator force : Mapbox v3 passe en projection "globe" aux petits zooms
              // (traces de plusieurs centaines de km) et fitBounds n'y respecte plus le
              // padding -> la trace passait sous le profil topo. Le PDF est aussi en mercator.
              projection: "mercator",
              interactive: !1,
              attributionControl: !1,
              preserveDrawingBuffer: !0,
            })),
            m.on("load", () => {
              ((g = !0),
                m.addSource("gpx-trace", {
                  type: "geojson",
                  data: { type: "FeatureCollection", features: [] },
                }),
                m.addLayer({
                  id: "gpx-line",
                  type: "line",
                  source: "gpx-trace",
                  layout: { "line-join": "round", "line-cap": "round" },
                  paint: { "line-color": p.traceColor, "line-width": 3 },
                }),
                U({ type: "FeatureCollection", features: [] }),
                p.gpxGeoJSON &&
                  p.gpxGeoJSON.features &&
                  p.gpxGeoJSON.features.length &&
                  k(),
                M(),
                (function () {
                  if (y) return;
                  if (
                    p.gpxGeoJSON &&
                    p.gpxGeoJSON.features &&
                    p.gpxGeoJSON.features.length
                  )
                    return;
                  var el = d("#poster-builder"),
                    ds = el && el.dataset;
                  if (!ds) return;
                  if (ds.preloadedTheme) {
                    try {
                      v(ds.preloadedTheme);
                    } catch (e) {}
                  }
                  var _gpxTraces = null;
                  if (ds.gpxTraces) {
                    try {
                      var _parsed = JSON.parse(ds.gpxTraces);
                      if (Array.isArray(_parsed) && _parsed.length)
                        _gpxTraces = _parsed;
                    } catch (e) {
                      console.warn("[ULTRACE] gpxTraces parse failed:", e);
                    }
                  }
                  if (_gpxTraces) {
                    var _dz2 = d("#gpx-dropzone");
                    if (_dz2) _dz2.style.display = "none";
                    var _gp2 = d("#gpx-predefined");
                    if (_gp2) {
                      _gp2.style.display = "";
                      _gp2.innerHTML = "";
                      var _lbl = document.createElement("label");
                      _lbl.className = "label";
                      _lbl.textContent = "Choisir votre distance";
                      _gp2.appendChild(_lbl);
                      var _grp = document.createElement("div");
                      _grp.className = "gpx-btn-group";
                      _gp2.appendChild(_grp);
                      var _defIdx = 0;
                      _gpxTraces.forEach(function (trace, idx) {
                        var btn = document.createElement("button");
                        btn.type = "button";
                        btn.className =
                          "gpx-btn" +
                          (idx === _defIdx ? " gpx-btn--selected" : "");
                        btn.dataset.index = idx;
                        btn.innerHTML =
                          '<span class="gpx-btn__distance">' +
                          (trace.label || "") +
                          "</span>";
                        btn.addEventListener("click", function () {
                          loadMetafieldTrace(_gpxTraces, idx, _grp);
                        });
                        _grp.appendChild(btn);
                      });
                      loadMetafieldTrace(_gpxTraces, _defIdx, _grp);
                    }
                  } else if (ds.preloadedGpx) {
                    var _dz = d("#gpx-dropzone");
                    if (_dz) _dz.style.display = "none";
                    var _gp = d("#gpx-predefined");
                    if (_gp) _gp.style.display = "none";
                  }
                  function loadMetafieldTrace(traces, idx, group) {
                    var trace = traces[idx];
                    if (!trace) return;
                    if (group) {
                      group
                        .querySelectorAll(".gpx-btn")
                        .forEach(function (b) {
                          b.classList.remove("gpx-btn--selected");
                        });
                      var sel = group.querySelector(
                        '[data-index="' + idx + '"]',
                      );
                      if (sel) sel.classList.add("gpx-btn--selected");
                    }
                    if (trace.url) S(trace.url);
                    if (trace.raceName) {
                      p.title = trace.raceName;
                      var ti = d("#poster-title");
                      if (ti) ti.value = p.title;
                    }
                    if (trace.distance != null && trace.distance !== "") {
                      p.distance = String(trace.distance);
                      var di = d("#poster-distance");
                      if (di) di.value = p.distance;
                    }
                    if (trace.hike != null && trace.hike !== "") {
                      p.elevation = String(trace.hike);
                      var ei = d("#poster-elevation");
                      if (ei) ei.value = p.elevation;
                    }
                    if (trace.day != null && trace.day !== "") {
                      p.day = String(trace.day);
                      var dayI = d("#poster-day");
                      if (dayI) dayI.value = p.day;
                    }
                    try {
                      M();
                    } catch (e) {}
                  }
                  if (ds.preloadedTitle) {
                    p.title = ds.preloadedTitle;
                    var _t = d("#poster-title");
                    if (_t) _t.value = p.title;
                  }
                  if (ds.preloadedDistance) {
                    p.distance = ds.preloadedDistance;
                    var _di = d("#poster-distance");
                    if (_di) _di.value = p.distance;
                  }
                  if (ds.preloadedElevation) {
                    p.elevation = ds.preloadedElevation;
                    var _el = d("#poster-elevation");
                    if (_el) _el.value = p.elevation;
                  }
                  if (ds.preloadedDate) {
                    var _pt = ds.preloadedDate.split("-");
                    if (_pt.length === 3) {
                      p.year = _pt[0];
                      p.month = String(parseInt(_pt[1], 10));
                      p.day = String(parseInt(_pt[2], 10));
                      var _yr = d("#poster-year");
                      if (_yr) _yr.value = p.year;
                      var _mo = d("#poster-month");
                      if (_mo) _mo.value = p.month;
                      var _dy = d("#poster-day");
                      if (_dy) _dy.value = p.day;
                    }
                  }
                  if (ds.preloadedName !== undefined) {
                    p.name = ds.preloadedName;
                    var _nm = d("#poster-name");
                    if (_nm) _nm.value = p.name;
                  }
                  if (ds.preloadedQuote !== undefined) {
                    p.quote = ds.preloadedQuote;
                    var _qt = d("#poster-quote");
                    if (_qt) _qt.value = p.quote;
                  }
                  if (ds.preloadedTopo !== undefined) {
                    p.withTopo = "1" === ds.preloadedTopo;
                    var _tg = d("#topo-toggle");
                    if (_tg) _tg.checked = p.withTopo;
                  }
                  var _fv = document.querySelector(
                    ".step-indicator__item--active[data-step]",
                  );
                  if (_fv) {
                    try {
                      b(parseInt(_fv.dataset.step, 10));
                    } catch (e) {}
                  }
                  try {
                    M();
                  } catch (e) {}
                  if (ds.preloadedGpx) {
                    setTimeout(function () {
                      S(ds.preloadedGpx);
                      if (ds.preloadedTitle) {
                        p.title = ds.preloadedTitle;
                        var q = d("#poster-title");
                        if (q) q.value = p.title;
                      }
                      if (ds.preloadedDistance) {
                        p.distance = ds.preloadedDistance;
                        var q = d("#poster-distance");
                        if (q) q.value = p.distance;
                      }
                      if (ds.preloadedElevation) {
                        p.elevation = ds.preloadedElevation;
                        var q = d("#poster-elevation");
                        if (q) q.value = p.elevation;
                      }
                      if (ds.preloadedDate) {
                        var pt = ds.preloadedDate.split("-");
                        if (pt.length === 3) {
                          p.year = pt[0];
                          p.month = String(parseInt(pt[1], 10));
                          p.day = String(parseInt(pt[2], 10));
                          var yr = d("#poster-year");
                          if (yr) yr.value = p.year;
                          var mo = d("#poster-month");
                          if (mo) mo.value = p.month;
                          var dy = d("#poster-day");
                          if (dy) dy.value = p.day;
                        }
                      }
                      if (ds.preloadedName !== undefined) {
                        p.name = ds.preloadedName;
                        var nm = d("#poster-name");
                        if (nm) nm.value = p.name;
                      }
                      if (ds.preloadedQuote !== undefined) {
                        p.quote = ds.preloadedQuote;
                        var qt = d("#poster-quote");
                        if (qt) qt.value = p.quote;
                      }
                      if (ds.preloadedTopo !== undefined) {
                        p.withTopo = "1" === ds.preloadedTopo;
                        var tg = d("#topo-toggle");
                        if (tg) tg.checked = p.withTopo;
                      }
                      try {
                        M();
                      } catch (e) {}
                    }, 600);
                  }
                })());
            }));
        }
      })(),
      M());
  }
  function x() {
    const e = {
      "poster-title": p.title,
      "poster-day": p.day,
      "poster-month": p.month,
      "poster-year": p.year,
      "poster-days": p.days,
      "poster-hour": p.hour,
      "poster-minute": p.minute,
      "poster-second": p.second,
      "poster-distance": p.distance,
      "poster-elevation": p.elevation,
      "poster-bib": p.bib,
      "poster-name": p.name,
      "poster-quote": p.quote,
    };
    Object.entries(e).forEach(([e, t]) => {
      const o = document.getElementById(e);
      o && (o.value = t);
    });
    const t = d("#topo-toggle");
    (t && (t.checked = p.withTopo),
      _("#trace-color-picker", p.traceColor),
      _("#text-color-picker", p.textColor),
      N());
  }
  function b(e) {
    if (e > 2 && !p.gpxGeoJSON) {
      const e = r[p.theme];
      if (!e || !Array.isArray(e.gpxSource))
        return void j(
          "Veuillez importer un fichier GPX avant de continuer.",
          "error",
        );
    }
    ((p.currentStep = e),
      u(".step-indicator__item").forEach((t) => {
        const o = parseInt(t.dataset.step);
        (t.classList.toggle("step-indicator__item--active", o === e),
          t.classList.toggle("step-indicator__item--completed", o < e));
      }),
      u(".step-panel").forEach((t) => {
        t.classList.toggle(
          "step-panel--active",
          parseInt(t.dataset.stepPanel) === e,
        );
      }),
      4 === e &&
        (P("#summary-theme", r[p.theme].name),
        P("#summary-title", p.title || "--"),
        P("#summary-distance", p.distance ? p.distance + " km" : "--"),
        P(
          "#summary-date",
          p.day && p.month && p.year
            ? O(p.day) + "/" + O(p.month) + "/" + p.year
            : "--",
        ),
        P(
          "#summary-time",
          raceTime() || "--",
        )),
      e >= 3 && n().catch(() => {}),
      window.scrollTo({
        top: d("#step-indicator").offsetTop - 20,
        behavior: "smooth",
      }));
  }
  function v(e) {
    p.theme = e;
    const t = r[e],
      o = c[e] || c.classic;
    Object.assign(p, {
      gpxXml: null,
      gpxGeoJSON: null,
      gpxFileName: null,
      gpxFiles: [],
      ...o,
    });
    gpxRenderList();
    const a = d("#poster-inner"),
      n = Array.isArray(t.gpxSource);
    a && (a.style.opacity = n ? "0" : "1");
    const s = d("#gpx-dropzone");
    if (s) {
      s.classList.remove("gpx-dropzone--has-file");
      const e = d("#gpx-filename");
      e && (e.style.display = "none");
    }
    const i = "upload" === t.gpxSource;
    if (
      ((d("#gpx-dropzone").style.display = i ? "" : "none"),
      (d("#gpx-predefined").style.display = n ? "" : "none"),
      (d("#cartography-options").style.display = t.showCartography
        ? ""
        : "none"),
      (d("#topo-toggle-row").style.display = t.showTopo ? "" : "none"),
      (d("#color-options").style.display = t.showColors ? "" : "none"),
      (d("#text-color-options").style.display = t.showColors ? "" : "none"),
      n)
    ) {
      const e = d("#gpx-predefined");
      e.innerHTML = "";
      const o = document.createElement("label");
      ((o.className = "label"),
        (o.textContent = "Choisir votre distance"),
        e.appendChild(o));
      const a = document.createElement("div");
      ((a.className = "gpx-btn-group"), e.appendChild(a));
      const n = t.gpxSource.length - 1;
      (t.gpxSource.forEach((e, o) => {
        const r = document.createElement("button");
        ((r.type = "button"),
          (r.className = "gpx-btn" + (o === n ? " gpx-btn--selected" : "")),
          (r.dataset.index = o),
          (r.innerHTML =
            '<span class="gpx-btn__distance">' + e.label + "</span>"),
          r.addEventListener("click", () => l(t, o, a)),
          a.appendChild(r));
      }),
        y || l(t, n, a));
    }
    function l(e, t, o) {
      const a = e.gpxSource[t];
      if (!a) return;
      if (o) {
        o.querySelectorAll(".gpx-btn").forEach((e) =>
          e.classList.remove("gpx-btn--selected"),
        );
        const e = o.querySelector('[data-index="' + t + '"]');
        e && e.classList.add("gpx-btn--selected");
      }
      const n = d("#poster-inner");
      (n && (n.style.opacity = "1"),
        S(a.url),
        (p.title = a.raceName || ""),
        (p.distance = a.distance || ""),
        (p.elevation = a.hike || ""),
        a.day && (p.day = String(a.day)),
        (d("#poster-title").value = p.title),
        (d("#poster-distance").value = p.distance),
        (d("#poster-elevation").value = p.elevation),
        (d("#poster-day").value = p.day));
    }
    "transparent" === t.mapStyle && (p.cartography = "transparent");
    const m = {
      "poster-name": p.name,
      "poster-day": p.day,
      "poster-month": p.month,
      "poster-year": p.year,
      "poster-title": p.title,
      "poster-distance": p.distance,
      "poster-elevation": p.elevation,
      "poster-days": p.days,
      "poster-hour": p.hour,
      "poster-minute": p.minute,
      "poster-second": p.second,
      "poster-bib": p.bib,
      "poster-quote": p.quote,
    };
    Object.entries(m).forEach(([e, t]) => {
      const o = document.getElementById(e);
      o && (o.value = t);
    });
    const g = d("#topo-toggle");
    g && (g.checked = p.withTopo);
    const h = d("#poster-logos");
    (h && (h.style.display = t.logos ? "" : "none"),
      u(".map-style-btn").forEach((e) =>
        e.classList.toggle(
          "map-style-btn--selected",
          e.dataset.style === p.cartography,
        ),
      ),
      _("#trace-color-picker", p.traceColor),
      _("#text-color-picker", p.textColor),
      N(),
      k(),
      M());
  }
  // ------------------------------------------------------------------
  // Import GPX : un ou plusieurs fichiers. Plusieurs fichiers (étapes, jours…)
  // sont remis bout à bout automatiquement : on part de l'extrémité la plus
  // isolée, puis on enchaîne le fichier dont une extrémité est la plus proche de
  // la fin courante (retourné si besoin). Chaque fichier garde ses segments :
  // pas de ligne droite entre deux étapes, et le profil suit l'ordre du parcours.
  // ------------------------------------------------------------------
  function w(e) {
    gpxLoadFiles([e], !1);
  }
  function gpxLoadFiles(list, append) {
    const files = Array.prototype.filter.call(list || [], (f) =>
      /\.gpx$/i.test(f.name),
    );
    if (!files.length) return;
    // trace restaurée depuis le panier (pas de fichiers en mémoire) : on la garde comme 1er fichier
    if (append && !(p.gpxFiles && p.gpxFiles.length) && p.gpxGeoJSON && p.gpxGeoJSON.features.length)
      p.gpxFiles = [{ name: p.gpxFileName || "trace.gpx", features: p.gpxGeoJSON.features, xml: p.gpxXml }];
    Promise.all(
      files.map(
        (f) =>
          new Promise((ok) => {
            const r = new FileReader();
            ((r.onload = (ev) => ok({ name: f.name, text: ev.target.result })),
              (r.onerror = () => ok(null)),
              r.readAsText(f));
          }),
      ),
    ).then((read) => {
      const parsed = read
        .filter(Boolean)
        .map((f) => gpxParse(f.text, f.name))
        .filter((f) => f.features.length);
      if (!parsed.length) return;
      ((p.gpxFiles = (append ? p.gpxFiles || [] : []).concat(parsed)), gpxApply());
    });
  }
  function gpxParse(text, name) {
    const xml = new DOMParser().parseFromString(text, "application/xml"),
      trk = xml.getElementsByTagName("trk"),
      features = [];
    for (let i = 0; i < trk.length; i++) {
      const segs = trk[i].getElementsByTagName("trkseg");
      for (let j = 0; j < segs.length; j++) {
        const pts = segs[j].getElementsByTagName("trkpt"),
          c = [];
        for (let k = 0; k < pts.length; k++) {
          const ele = pts[k].getElementsByTagName("ele")[0];
          c.push([
            parseFloat(pts[k].getAttribute("lon")),
            parseFloat(pts[k].getAttribute("lat")),
            ele ? parseFloat(ele.textContent) : 0,
          ]);
        }
        c.length > 1 &&
          features.push({ type: "Feature", geometry: { type: "LineString", coordinates: c }, properties: {} });
      }
    }
    return { name: name, features: features, xml: xml };
  }
  function gpxEnds(f) {
    const fs = f.features,
      a = fs[0].geometry.coordinates,
      b = fs[fs.length - 1].geometry.coordinates;
    return [a[0], b[b.length - 1]];
  }
  function gpxDist(a, b) {
    const k = Math.cos(((a[1] + b[1]) / 2) * (Math.PI / 180));
    return Math.hypot((a[0] - b[0]) * k, a[1] - b[1]);
  }
  function gpxReverse(f) {
    return {
      name: f.name,
      src: f.src || f,
      rev: !f.rev,
      features: f.features
        .slice()
        .reverse()
        .map((ft) => ({ type: "Feature", properties: {}, geometry: { type: "LineString", coordinates: ft.geometry.coordinates.slice().reverse() } })),
    };
  }
  function gpxChain(files) {
    if (files.length < 2) return files.slice();
    files = files.map((f) => ({ name: f.name, features: f.features, src: f, rev: !1 }));
    // départ : l'extrémité la plus éloignée de toutes les extrémités des autres fichiers
    let best = null;
    files.forEach((f, i) => {
      gpxEnds(f).forEach((pt, side) => {
        let m = Infinity;
        files.forEach((g, j) => {
          if (j !== i) gpxEnds(g).forEach((q) => (m = Math.min(m, gpxDist(pt, q))));
        });
        (!best || m > best.m) && (best = { i: i, side: side, m: m });
      });
    });
    // boucle (toutes les extrémités se touchent, < ~200 m) : départ arbitraire, on garde le 1er fichier importé dans son sens
    best.m < 0.002 && (best = { i: 0, side: 0, m: 0 });
    const left = files.slice(),
      first = left.splice(best.i, 1)[0],
      out = [best.side === 1 ? gpxReverse(first) : first];
    for (; left.length; ) {
      const end = gpxEnds(out[out.length - 1])[1];
      let pick = 0,
        rev = !1,
        dm = Infinity;
      left.forEach((g, j) => {
        const e = gpxEnds(g),
          d0 = gpxDist(end, e[0]),
          d1 = gpxDist(end, e[1]);
        (d0 < dm && ((dm = d0), (pick = j), (rev = !1)),
          d1 < dm && ((dm = d1), (pick = j), (rev = !0)));
      });
      const g = left.splice(pick, 1)[0];
      out.push(rev ? gpxReverse(g) : g);
    }
    // sens du parcours : le 1er fichier importé garde son sens d'origine
    const firstOut = out.find((f) => f.src === files[0].src);
    return firstOut && firstOut.rev ? out.reverse().map(gpxReverse) : out;
  }
  function gpxXmlFrom(features) {
    const segs = features
      .map(
        (f) =>
          "<trkseg>" +
          f.geometry.coordinates
            .map((c) => '<trkpt lat="' + c[1] + '" lon="' + c[0] + '"><ele>' + (c[2] || 0) + "</ele></trkpt>")
            .join("") +
          "</trkseg>",
      )
      .join("");
    return new DOMParser().parseFromString(
      '<?xml version="1.0" encoding="UTF-8"?><gpx version="1.1"><trk>' + segs + "</trk></gpx>",
      "application/xml",
    );
  }
  function gpxApply() {
    const files = p.gpxFiles || [];
    if (!files.length) {
      ((p.gpxGeoJSON = null), (p.gpxXml = null), (p.gpxFileName = null), gpxRenderList());
      const btn = d("#btn-step2-next");
      btn && (btn.classList.add("btn--disabled"), (btn.disabled = !0));
      (m && g && k(), M());
      return;
    }
    const chained = gpxChain(files),
      features = chained.flatMap((f) => f.features);
    ((p.gpxFileName = files.map((f) => f.name).join(" + ")),
      (p.gpxGeoJSON = { type: "FeatureCollection", features: features }),
      (p.gpxXml = files.length === 1 && files[0].xml ? files[0].xml : gpxXmlFrom(features)),
      gpxRenderList(),
      gpxAfterLoad());
  }
  function gpxRenderList() {
    const files = p.gpxFiles || [],
      fn = d("#gpx-filename"),
      dz = d("#gpx-dropzone"),
      box = d("#gpx-files"),
      ul = d("#gpx-files-list");
    if (fn) {
      fn.textContent = files.length === 1 ? files[0].name : files.length ? files.length + " fichiers GPX" : "";
      fn.style.display = files.length ? "" : "none";
    }
    dz && dz.classList.toggle("gpx-dropzone--has-file", !!files.length);
    if (box) box.style.display = files.length ? "" : "none";
    if (!ul) return;
    ul.innerHTML = "";
    files.forEach((f, i) => {
      const li = document.createElement("li");
      li.className = "gpx-files__item";
      const name = document.createElement("span");
      name.className = "gpx-files__name";
      name.textContent = f.name;
      const rm = document.createElement("button");
      ((rm.type = "button"),
        (rm.className = "gpx-files__remove"),
        rm.setAttribute("aria-label", "Retirer " + f.name),
        (rm.textContent = "×"),
        rm.addEventListener("click", () => {
          (p.gpxFiles.splice(i, 1), gpxApply());
        }));
      (li.appendChild(name), li.appendChild(rm), ul.appendChild(li));
    });
  }
  function S(e, t) {
    ((t = t || 1),
      fetch(e)
        .then(function (e) {
          if (!e.ok) throw new Error("HTTP " + e.status);
          return e.text();
        })
        .then(function (t) {
          if (!t || t.length < 50) throw new Error("Empty GPX");
          ((p.gpxFileName = e.split("/").pop()), L(t));
        })
        .catch(function (o) {
          (console.warn(
            "[ULTRACE] GPX load failed (attempt " + t + "):",
            o.message,
          ),
            t < 3 &&
              setTimeout(function () {
                S(e, t + 1);
              }, 500 * t));
        }));
  }
  function L(e) {
    ((p.gpxFiles = [gpxParse(e, p.gpxFileName || "trace.gpx")]), gpxApply());
  }
  function gpxAfterLoad() {
    const o = d("#btn-step2-next");
    o && (o.classList.remove("btn--disabled"), (o.disabled = !1));
    const a = d("#poster-inner");
    a && (a.style.opacity = "1");
    const n = d("#prop-gpx-filename");
    (n && (n.value = p.gpxFileName || ""),
      m && g
        ? k()
        : m &&
          m.once("load", function () {
            k();
          }),
      M());
  }
  function gpxSegments() {
    const f = p.gpxGeoJSON && p.gpxGeoJSON.features;
    if (!f || !f.length) return [];
    return f
      .map((f) =>
        (f.geometry && f.geometry.coordinates ? f.geometry.coordinates : []).map(
          (e) => [
            Math.round(1e5 * e[0]) / 1e5,
            Math.round(1e5 * e[1]) / 1e5,
            null != e[2] ? Math.round(e[2]) : 0,
          ],
        ),
      )
      .filter((s) => s.length);
  }
  // Charge utile de /api/poster/save : le trace complet d'un gros GPX (>95 000 points)
  // depassait la limite de 4,5 Mo de Vercel (FUNCTION_PAYLOAD_TOO_LARGE). On n'envoie
  // plus que `segments` (le serveur reconstruit la liste a plat) et on echantillonne
  // au-dela de MAX_API_POINTS — a l'echelle de l'affiche, un point tous les quelques
  // metres est deja invisible. Le fichier GPX joint au panier, lui, reste complet.
  const MAX_API_POINTS = 3e4;
  function apiSegments(max) {
    const segs = gpxSegments(),
      total = segs.reduce((n, s) => n + s.length, 0);
    max = max || MAX_API_POINTS;
    if (total <= max) return segs;
    const step = Math.ceil(total / max);
    return segs.map((s) => {
      const out = [];
      for (let i = 0; i < s.length; i += step) out.push(s[i]);
      if (s.length && out[out.length - 1] !== s[s.length - 1]) out.push(s[s.length - 1]);
      return out;
    });
  }
  let C = "dark";
  function U(a) {
    if (!m || !g) return;
    var c =
        a && a.features && a.features.length
          ? a.features.flatMap((f) =>
              f.geometry && f.geometry.coordinates ? f.geometry.coordinates : [],
            )
          : null,
      sd = { type: "FeatureCollection", features: [] },
      ed = { type: "FeatureCollection", features: [] };
    if (c && c.length >= 2) {
      var s = c[0],
        e = c[c.length - 1];
      var R = 6371e3,
        PI = Math.PI,
        tr = function (d) {
          return (d * PI) / 180;
        };
      var dL = tr(e[1] - s[1]),
        dG = tr(e[0] - s[0]),
        la1 = tr(s[1]),
        la2 = tr(e[1]);
      var X =
        Math.sin(dL / 2) * Math.sin(dL / 2) +
        Math.sin(dG / 2) * Math.sin(dG / 2) * Math.cos(la1) * Math.cos(la2);
      if (2 * R * Math.asin(Math.sqrt(X)) >= 100) {
        sd.features = [
          {
            type: "Feature",
            geometry: { type: "Point", coordinates: [s[0], s[1]] },
            properties: {},
          },
        ];
        ed.features = [
          {
            type: "Feature",
            geometry: { type: "Point", coordinates: [e[0], e[1]] },
            properties: {},
          },
        ];
      } else {
        ed.features = [
          {
            type: "Feature",
            geometry: { type: "Point", coordinates: [s[0], s[1]] },
            properties: {},
          },
        ];
      }
    }
    var ss = m.getSource("gpx-start");
    ss
      ? ss.setData(sd)
      : m.addSource("gpx-start", { type: "geojson", data: sd });
    var es = m.getSource("gpx-end");
    es ? es.setData(ed) : m.addSource("gpx-end", { type: "geojson", data: ed });
    if (p.showStart === !1) {
      if (m.getLayer("gpx-start-circle")) m.removeLayer("gpx-start-circle");
      if (m.getLayer("gpx-end-circle")) m.removeLayer("gpx-end-circle");
    } else {
      if (!m.getLayer("gpx-start-circle"))
        m.addLayer({
          id: "gpx-start-circle",
          type: "circle",
          source: "gpx-start",
          paint: {
            "circle-color": "#ffffff",
            "circle-stroke-color": p.traceColor,
            "circle-stroke-width": 1.5,
            "circle-radius": 3,
          },
        });
      if (!m.getLayer("gpx-end-circle"))
        m.addLayer({
          id: "gpx-end-circle",
          type: "circle",
          source: "gpx-end",
          paint: {
            "circle-color": p.traceColor,
            "circle-stroke-color": "#ffffff",
            "circle-stroke-width": 1.5,
            "circle-radius": 4,
          },
        });
    }
  }
  function k() {
    if (!m || !g) return;
    const e = r[p.theme],
      t = "transparent" === p.cartography || "transparent" === e.mapStyle,
      o = ["full_black", "full_white"].includes(p.cartography),
      a = p.gpxGeoJSON || { type: "FeatureCollection", features: [] };
    let n = p.cartography;
    if ((t ? (n = "transparent") : o && (n = p.cartography), n === C)) {
      const e = m.getSource("gpx-trace");
      return (
        e
          ? (e.setData(a),
            m.setPaintProperty("gpx-line", "line-color", p.traceColor),
            U(a),
            m.getLayer("gpx-start-circle") &&
              m.setPaintProperty(
                "gpx-start-circle",
                "circle-stroke-color",
                p.traceColor,
              ),
            m.getLayer("gpx-end-circle") &&
              m.setPaintProperty(
                "gpx-end-circle",
                "circle-color",
                p.traceColor,
              ))
          : (m.addSource("gpx-trace", { type: "geojson", data: a }),
            m.addLayer({
              id: "gpx-line",
              type: "line",
              source: "gpx-trace",
              layout: { "line-join": "round", "line-cap": "round" },
              paint: { "line-color": p.traceColor, "line-width": 3 },
            }),
            U(a)),
        void (p.gpxGeoJSON && E())
      );
    }
    if (((C = n), t)) m.setStyle({ version: 8, sources: {}, layers: [] });
    else if (o) {
      const e = "full_black" === p.cartography ? "#000" : "#fff";
      m.setStyle({
        version: 8,
        sources: {},
        layers: [
          { id: "bg", type: "background", paint: { "background-color": e } },
        ],
      });
    } else s[p.cartography] && m.setStyle(s[p.cartography]);
    m.once("style.load", () => {
      (m.addSource("gpx-trace", { type: "geojson", data: a }),
        m.addLayer({
          id: "gpx-line",
          type: "line",
          source: "gpx-trace",
          layout: { "line-join": "round", "line-cap": "round" },
          paint: { "line-color": p.traceColor, "line-width": 3 },
        }),
        U(a),
        p.gpxGeoJSON && E());
    });
  }
  function E() {
    if (!m || !p.gpxGeoJSON?.features?.length) return;
    const e = p.gpxGeoJSON.features.flatMap((e) => e.geometry.coordinates);
    if (!e.length) return;
    const t = e.reduce(
        (e, t) => e.extend([t[0], t[1]]),
        new mapboxgl.LngLatBounds([e[0][0], e[0][1]], [e[0][0], e[0][1]]),
      ),
      o = p.withTopo
        ? { top: 30, right: 30, bottom: 85, left: 30 } // topo = 70 px -> 15 px d'air au-dessus
        : { top: 30, right: 30, bottom: 30, left: 30 };
    m.fitBounds(t, { padding: o, duration: 1e3 });
  }
  function T(e, t, o) {
    const a = d(e);
    a &&
      ((a.innerHTML = ""),
      i.forEach((e) => {
        const n = document.createElement("button");
        var r;
        ((n.type = "button"),
          (n.className =
            "color-swatch" +
            (e === t ? " color-swatch--selected" : "") +
            ((r = e),
            (299 * parseInt(r.slice(1, 3), 16) +
              587 * parseInt(r.slice(3, 5), 16) +
              114 * parseInt(r.slice(5, 7), 16)) /
              1e3 >
            200
              ? " color-swatch--light"
              : "")),
          (n.style.backgroundColor = e),
          (n.dataset.color = e),
          n.addEventListener("click", () => {
            (a
              .querySelectorAll(".color-swatch")
              .forEach((e) => e.classList.remove("color-swatch--selected")),
              n.classList.add("color-swatch--selected"),
              o(e));
          }),
          a.appendChild(n));
      }));
  }
  function _(e, t) {
    const o = d(e);
    o &&
      o
        .querySelectorAll(".color-swatch")
        .forEach((e) =>
          e.classList.toggle("color-swatch--selected", e.dataset.color === t),
        );
  }
  function N() {
    const e = r[p.theme];
    (A("#prop-theme", p.theme),
      A("#prop-theme-display", e ? e.name : p.theme),
      A("#prop-cartography", p.cartography),
      A("#prop-trace-color", p.traceColor),
      A("#prop-text-color", p.textColor),
      A("#prop-with-topo", p.withTopo ? "oui" : "non"),
      A("#prop-show-start", p.showStart ? "oui" : "non"),
      A("#prop-title-display", p.title),
      A("#prop-name-display", p.name),
      A("#prop-bib-display", p.bib || ""),
      A("#prop-distance-display", p.distance ? p.distance + " km" : ""),
      A(
        "#prop-elevation-display",
        p.elevation && parseInt(p.elevation) > 0 ? p.elevation + "m D+" : "",
      ),
      p.day &&
        p.month &&
        p.year &&
        A("#prop-date-display", O(p.day) + "." + O(p.month) + "." + p.year),
      A("#prop-time-display", raceTime()));
  }
  function A(e, t) {
    const o = d(e);
    o && (o.value = t || "");
  }
  function O(e) {
    return String(e).padStart(2, "0");
  }
  // Temps de course « 2J 14H32'10'' » : chaque partie vide (jours, heures, minutes,
  // secondes) est omise — « 14H32'10'' », « 2J 32'10'' »… Jours à 0 = omis.
  // Même règle que le PDF (pdf-api/templates/poster.html).
  function raceTime() {
    const has = (v) => v != null && String(v).trim() !== "";
    const days = parseInt(p.days, 10) > 0 ? parseInt(p.days, 10) + "J" : "";
    const hms =
      (has(p.hour) ? O(String(p.hour).trim()) + "H" : "") +
      (has(p.minute) ? O(String(p.minute).trim()) + "'" : "") +
      (has(p.second) ? O(String(p.second).trim()) + "''" : "");
    return [days, hms].filter(Boolean).join(" ");
  }
  function j(e, t) {
    const o = d(".poster-notification");
    o && o.remove();
    const a = document.createElement("div");
    ((a.className = "poster-notification poster-notification--" + t),
      (a.innerHTML =
        '<div class="poster-notification__content"><span class="poster-notification__icon">' +
        ("success" === t ? "&#10003;" : "&#9888;") +
        '</span><span class="poster-notification__message">' +
        e +
        '</span><button class="poster-notification__close" type="button">&times;</button></div>'),
      document.body.appendChild(a));
    const n = setTimeout(() => a.remove(), "success" === t ? 3e3 : 6e3);
    (a
      .querySelector(".poster-notification__close")
      .addEventListener("click", () => {
        (clearTimeout(n), a.remove());
      }),
      requestAnimationFrame(() =>
        a.classList.add("poster-notification--visible"),
      ));
  }
  function M() {
    const e = d("#poster-inner"),
      t = d("#poster-text-area");
    if (!e || !t) return;
    const o = r[p.theme],
      a =
        p.withTopo &&
        p.gpxXml &&
        "full_black" !== p.cartography &&
        "full_white" !== p.cartography;
    "transparent" === p.cartography || "transparent" === o.mapStyle
      ? ((e.style.background = o.background || "#fff"),
        (e.style.backgroundColor = o.backgroundStart || o.background || "#fff"))
      : "full_black" === p.cartography
        ? (e.style.background = "#000")
        : (e.style.background = "#fff");
    const n = o.showColors ? p.textColor : o.textColor;
    ((t.style.color = n),
      t.querySelectorAll("h2, div, span").forEach(function (e) {
        e.style.color = n;
      }));
    const s = d("#poster-text-right");
    (s &&
      ((s.style.color = n),
      s.querySelectorAll("div").forEach(function (e) {
        e.style.color = n;
      })),
      "classic" === p.theme
        ? ((t.style.backgroundColor =
            "full_black" === p.cartography ? "#000" : "#fff"),
          (t.style.backdropFilter = ""),
          (t.style.webkitBackdropFilter = ""),
          (t.style.borderRadius = ""),
          (t.style.border = ""),
          (t.style.boxShadow = ""),
          (t.style.padding = ""),
          s &&
            ((s.style.backgroundColor = ""),
            (s.style.backdropFilter = ""),
            (s.style.webkitBackdropFilter = ""),
            (s.style.borderRadius = ""),
            (s.style.border = ""),
            (s.style.boxShadow = ""),
            (s.style.padding = "")))
        : ((t.style.backgroundColor = "transparent"),
          (t.style.backdropFilter = ""),
          (t.style.webkitBackdropFilter = ""),
          (t.style.borderRadius = ""),
          (t.style.border = ""),
          (t.style.boxShadow = ""),
          (t.style.padding = ""),
          s &&
            ((s.style.backgroundColor = ""),
            (s.style.backdropFilter = ""),
            (s.style.webkitBackdropFilter = ""),
            (s.style.borderRadius = ""),
            (s.style.border = ""),
            (s.style.boxShadow = ""),
            (s.style.padding = ""))));
    const i = d("#poster-firstname-rotated");
    if (
      (i &&
        ((i.textContent = p.name ? p.name.toUpperCase() : ""),
        (i.style.color = n),
        (i.style.display = p.name ? "" : "none"),
        (i.style.fontSize = "bottom" === o.topoPosition ? "14px" : "")),
      s &&
        (p.name && p.name.length > 0
          ? s.classList.remove("poster-text-right--no-name")
          : s.classList.add("poster-text-right--no-name")),
      P("#poster-display-title", p.title || ""),
      p.day && p.month && p.year
        ? P("#poster-display-date", O(p.day) + "." + O(p.month) + "." + p.year)
        : P("#poster-display-date", ""),
      p.distance)
    ) {
      const e = d("#poster-display-distance");
      e && (e.innerHTML = "<b>" + p.distance + "</b> km");
    } else P("#poster-display-distance", "");
    if (p.elevation && parseInt(p.elevation) > 0) {
      const e = d("#poster-display-hike");
      e && (e.innerHTML = "<b>" + p.elevation + "m</b> D+");
    } else P("#poster-display-hike", "");
    if (
      (P("#poster-display-quote", p.quote ? p.quote.toUpperCase() : ""),
      P("#poster-display-bib", p.bib ? "N° " + p.bib : ""),
      P("#poster-display-time", raceTime()),
      "bottom" === o.topoPosition && a)
    ) {
      const o = e.querySelector(".poster-map-area");
      (o && (o.style.height = Math.round(0.83 * e.offsetHeight) + "px"),
        (t.style.bottom = "auto"),
        (t.style.top = "auto"),
        (t.style.height = "auto"),
        (t.style.justifyContent = "flex-start"),
        (t.style.gap = "2px"));
      const a = d("#poster-topo-wrap");
      (a && (a.style.display = "none"),
        G(!0),
        requestAnimationFrame(() => {
          const o = e.offsetHeight,
            a = Math.round(0.17 * o),
            n = d("#poster-topo-bottom");
          if (n) {
            n.style.height = a + "px";
            const e = d("#poster-topo-canvas-bottom");
            e && ((e.style.height = a + "px"), G(!0));
          }
          const r = a + 3;
          ((t.style.bottom = r + "px"),
            (t.style.top = "auto"),
            s && ((s.style.top = "auto"), (s.style.bottom = r + "px")),
            requestAnimationFrame(() => I()));
        }));
    } else {
      ((t.style.bottom = "25px"),
        (t.style.top = ""),
        (t.style.height = ""),
        (t.style.justifyContent = ""),
        (t.style.gap = ""),
        (t.style.zIndex = ""),
        (t.style.left = ""),
        (t.style.right = ""),
        (t.style.padding = ""),
        s &&
          ((s.style.bottom = "25px"),
          (s.style.top = ""),
          (s.style.zIndex = "")),
        i && (i.style.opacity = ""));
      const o = e.querySelector(".poster-map-area");
      o &&
        ((o.style.position = ""),
        (o.style.top = ""),
        (o.style.left = ""),
        (o.style.width = ""),
        (o.style.height = ""),
        (o.style.zIndex = ""));
      const n = d("#poster-topo-bottom");
      (n && (n.style.display = "none"),
        (function (e) {
          const t = d("#poster-topo-wrap"),
            o = d("#poster-topo-canvas");
          if (!t || !o) return;
          if (!e || !p.gpxXml) return void (t.style.display = "none");
          t.style.display = "";
          const a = r[p.theme],
            n = p.gpxXml.getElementsByTagName("trkpt");
          if (!n.length) return;
          const s = [],
            i = [];
          let l = null,
            c = null,
            u = 0;
          for (let e = 0; e < n.length; e++) {
            const t = n[e].getElementsByTagName("ele")[0];
            if (!t) continue;
            const o = parseFloat(n[e].getAttribute("lat")),
              a = parseFloat(n[e].getAttribute("lon")),
              r = parseFloat(t.textContent);
            (null !== l && null !== c && (u += D(l, c, o, a)),
              (l = o),
              (c = a),
              s.push(u),
              i.push(r));
          }
          const m = s.length > 1e3 ? 20 : 1,
            g = [],
            h = [];
          for (let e = 0; e < s.length; e += m) (g.push(s[e]), h.push(i[e]));
          if (g.length < 2) return;
          const y = Math.max(1, window.devicePixelRatio || 1),
            f = o.parentElement.offsetWidth || 400,
            x = 70;
          ((o.width = Math.round(f * y)),
            (o.height = Math.round(x * y)),
            (o.style.width = f + "px"),
            (o.style.height = "70px"));
          const b = o.getContext("2d");
          (b.setTransform(y, 0, 0, y, 0, 0),
            b.clearRect(0, 0, f, x),
            (b.imageSmoothingEnabled = !0),
            (b.imageSmoothingQuality = "high"));
          const v = Math.min.apply(null, g),
            w = Math.max.apply(null, g),
            S = Math.min.apply(null, h),
            L = f / (w - v || 1),
            C = 56 / (Math.max.apply(null, h) - S || 1),
            k = (e) => x - (e - S) * C;
          (b.beginPath(), b.moveTo(0, x));
          for (let e = 0; e < g.length; e++) {
            const t = (g[e] - v) * L;
            b.lineTo(t, k(h[e]));
          }
          (b.lineTo(f, x), b.closePath());
          const E = a.showColors ? "#ffffff" : a.textColor || "#ffffff";
          ((b.fillStyle = E), b.fill());
        })(a));
    }
    I();
  }
  let F,
    q = null;
  function R(e) {
    q || (q = document.createElement("canvas").getContext("2d"));
    const t = getComputedStyle(e),
      o = parseFloat(t.fontSize),
      a = parseFloat(t.lineHeight),
      n = isNaN(a) ? 1.2 * o : a,
      r = Math.max(0, (n - o) / 2),
      s = t.fontFamily.replace(/['"]/g, "");
    ((q.font = t.fontWeight + " " + t.fontSize + " " + s),
      (q.textBaseline = "alphabetic"));
    const i = q.measureText(e.textContent || "Xg"),
      l = i.fontBoundingBoxAscent || i.actualBoundingBoxAscent || 0.8 * o;
    return e.getBoundingClientRect().top + r + l;
  }
  function I() {
    const e = d("#poster-display-quote"),
      t = d("#poster-display-time");
    if (!e || !t) return;
    if (!e.textContent.trim() || !t.textContent.trim()) return;
    ((t.style.transform = ""), t.offsetHeight);
    const o = R(e),
      a = R(t) - o;
    Math.abs(a) < 0.5 ||
      ((t.style.transform = "translateY(" + -a + "px)"),
      (t.style.transformOrigin = "center bottom"));
  }
  function G(e) {
    const t = d("#poster-topo-bottom"),
      o = d("#poster-topo-canvas-bottom");
    if (!t || !o) return;
    if (!e || !p.gpxXml) return void (t.style.display = "none");
    t.style.display = "";
    const a = r[p.theme],
      n = p.gpxXml.getElementsByTagName("trkpt");
    if (!n.length) return;
    const s = [],
      i = [];
    let l = null,
      c = null,
      u = 0;
    for (let e = 0; e < n.length; e++) {
      const t = n[e].getElementsByTagName("ele")[0];
      if (!t) continue;
      const o = parseFloat(n[e].getAttribute("lat")),
        a = parseFloat(n[e].getAttribute("lon")),
        r = parseFloat(t.textContent);
      (null !== l && (u += D(l, c, o, a)),
        (l = o),
        (c = a),
        s.push(u),
        i.push(r));
    }
    const m = s.length > 1e3 ? 20 : 1,
      g = [],
      h = [];
    for (let e = 0; e < s.length; e += m) (g.push(s[e]), h.push(i[e]));
    if (g.length < 2) return;
    const y = Math.max(1, window.devicePixelRatio || 1),
      f = o.parentElement.offsetWidth || 450,
      x = o.parentElement.offsetHeight || 70;
    ((o.width = Math.round(f * y)),
      (o.height = Math.round(x * y)),
      (o.style.width = f + "px"),
      (o.style.height = x + "px"));
    const b = o.getContext("2d");
    (b.setTransform(y, 0, 0, y, 0, 0),
      b.clearRect(0, 0, f, x),
      (b.imageSmoothingEnabled = !0),
      (b.imageSmoothingQuality = "high"));
    const v = Math.min.apply(null, g),
      w = Math.max.apply(null, g),
      S = Math.min.apply(null, h),
      L = f / (w - v || 1),
      C = (x - 0.2 * x) / (Math.max.apply(null, h) - S || 1);
    (b.beginPath(), b.moveTo(0, x));
    for (let e = 0; e < g.length; e++)
      b.lineTo((g[e] - v) * L, x - (h[e] - S) * C);
    (b.lineTo(f, x),
      b.closePath(),
      (b.fillStyle = a.textColor || "#2b6b6b"),
      b.fill());
  }
  function D(e, t, o, a) {
    const n = (e) => (e * Math.PI) / 180,
      r = n(o - e),
      s = n(a - t),
      i =
        Math.sin(r / 2) ** 2 +
        Math.cos(n(e)) * Math.cos(n(o)) * Math.sin(s / 2) ** 2;
    return 12742 * Math.atan2(Math.sqrt(i), Math.sqrt(1 - i));
  }
  function P(e, t) {
    const o = d(e);
    o && (o.textContent = t);
  }
  (window.addEventListener("resize", () => {
    (clearTimeout(F),
      (F = setTimeout(() => {
        (m && m.resize(), M());
      }, 200)));
  }),
    "loading" === document.readyState
      ? document.addEventListener("DOMContentLoaded", f)
      : f());
})();
